import * as z from "zod";

export const getTiktokAdsOAuthURL = {
  name: "getTiktokAdsOAuthURL" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
